import { HeadSEO } from '@/components/seo/HeadSEO';
import { productRoadmap2026SeoStatic } from '@/constants/productRoadmap2026';
import { productRoadmapMessages } from '@/constants/productRoadmapMessages';
import React from 'react';
import { useIntl } from 'react-intl';

/**
 * Localized HeadSEO for Product Roadmap — must render under IntlProvider (_app).
 */
export const ProductRoadmap2026Head: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <HeadSEO
      title={formatMessage(productRoadmapMessages.seoTitle)}
      description={formatMessage(productRoadmapMessages.seoDescription)}
      {...productRoadmap2026SeoStatic}
    />
  );
};
